import Alerts from "./alerts.component";
import Loader from "../ui/Spinner.component";
import ErrorPage from "../ui/ErrorPage.component";
import { useShortList } from "../hooks/useShortList";

function ShortList() {
  const { isLoading, error, shortList } = useShortList();

  if (isLoading) return <Loader />;

  if (error) return <ErrorPage errorCode="500" description="Something went wrong , please try again later" />;

  return (
    <>
      <div>
        <h3 className="py-4">Short List : {shortList.alerts.length} items</h3>{" "}
      </div>
      <Alerts shortListContent={shortList} />
    </>
  );
}

export default ShortList;
